import type { ModalProps } from '@mantine/core';
import { Box, createStyles, Group, Modal } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import type React from 'react';
import type { PropsWithChildren } from 'react';

const useStyles = createStyles((theme) => ({
	body: {
		padding: `0 !important`,
	},
	footer: {
		position: 'sticky',
		bottom: 0,
		backgroundColor: theme.other.getColor('fill/primary/default'),
		borderTop: `1px solid ${theme.other.getColor('border/primary/default')}`,
		padding: theme.spacing.md,
	},
}));

export interface IScrollableModalProps {
	opened: boolean;
	onClose(): void;
	title: string | React.ReactNode;
	size?: ModalProps['size'];
	withTopPadding?: boolean;
	withDoneFooter?: boolean;
	footer?: React.ReactNode;
}

export function ScrollableModal({
	opened,
	onClose,
	title,
	children,
	size,
	withTopPadding,
	withDoneFooter = false,
	footer,
}: PropsWithChildren<IScrollableModalProps>) {
	const { classes } = useStyles();

	if (!opened) {
		return null;
	}

	return (
		<Modal.Root opened={opened} size={size} onClose={onClose}>
			<Modal.Overlay />
			<Modal.Content>
				<Modal.Header>
					{typeof title === 'string' ? (
						<Text size="md" weight="bold">
							{title}
						</Text>
					) : (
						title
					)}
					<Modal.CloseButton />
				</Modal.Header>
				<Modal.Body className={classes.body}>
					<Box px="md" py={withTopPadding ? 'md' : 0}>
						{children}
					</Box>
					{(withDoneFooter || footer) && (
						<Box className={classes.footer}>
							{withDoneFooter ? (
								<Group spacing="xs" position="right">
									<Button variant="default" onClick={onClose}>
										Done
									</Button>
								</Group>
							) : (
								footer
							)}
						</Box>
					)}
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	);
}
